import { IonButtons, IonMenuButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonItem, IonLabel, useIonRouter, IonIcon, IonCard, IonCardContent, IonSkeletonText, IonSpinner, IonChip, IonFab, IonFabButton, IonNote, IonRefresher, IonRefresherContent, RefresherEventDetail, IonImg, useIonViewDidEnter, useIonViewWillEnter, IonCardHeader, IonCardSubtitle, IonCardTitle, IonItemOption, IonItemOptions, IonItemSliding, IonButton, useIonAlert, IonBackButton, IonText, IonBadge, IonRow, IonCol, IonGrid, IonAccordionGroup, IonAccordion } from '@ionic/react';
import { add, addCircleOutline, addOutline, alarmOutline, alertCircleOutline, arrowBack, caretForwardCircleOutline, checkmarkCircleOutline, chevronBackOutline, copyOutline, helpCircleOutline, informationCircle, informationCircleOutline, locationOutline, navigateOutline, notificationsOutline, pauseCircleOutline, timerOutline, trashOutline, warningOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../AppProvider';
import { useDeviceContext } from '../components/useDeviceContext';

const checkDST = () => {
    const now = new Date();
    const januaryOffset = new Date(now.getFullYear(), 0, 1).getTimezoneOffset();
    const julyOffset = new Date(now.getFullYear(), 6, 1).getTimezoneOffset();    
    return now.getTimezoneOffset() !== januaryOffset;
};

const Timers: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [timers, setTimers] = useState<any[]>([]);
    const [dailyTimers, setDailyTimers] = useState<any[]>([]);
    const [lastLoadTime, setLastLoadTime] = useState<string>('');
    const [timerFreq, setTimerFreq] = useState<string>('');
    const [todayIsDST, setTodayIsDST] = useState<boolean>(false); 
    const [timerDST, setTimerDST] = useState<boolean>(false);
    const [isDeleting, setIsDeleting] = useState<boolean>(false);

    const { showLoader, setShowLoader, networkStatus, getAppStatus, authKey, authenticateMember, authorizedMember, accountSetupPct, setAccountSetupPct, alarms, limits, profiles, settings, getCurrentTimers, textLogoLoaded, fadeInTextLogo, SWTextLogo, SWFullHorizLogo, SWTextDarkLogo, timezones, getTimezones, timezonesIANA, getTimezonesIANA, timezoneIANAName, showToast, present, dismiss } = useAppContext();

    const router = useIonRouter();
    const [showAlert] = useIonAlert();
    const slidingRef = useRef<HTMLIonItemSlidingElement | null>(null);
    const deviceCtx = useDeviceContext();

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);

        const authenticate = async () => {
            const appstat = await getAppStatus();

            if (!networkStatus && appstat === 'No') {
                router.push('/connection', 'forward');
            } else {
                //setLoading(true);
                const authenticated = await authenticateMember();
                                    
                if (!authenticated || authenticated.mt == '') router.push('/login', 'forward');
                else {
                    setTodayIsDST(checkDST());
                    if (timezones.length === 0) await getTimezones();
                    if (timezonesIANA.length === 0) await getTimezonesIANA();
                    await getTimers(authenticated.mt); 
                    setLoading(false);
                    setShowLoader(false);
                }
            }
        };
        authenticate();
    }); 


    //
    // Account Set-Up functions
    //
    useEffect(() => {
        if (profiles.contacts >= 0) {
            let completePct = 0;
            if (authorizedMember.memberFirstName != '' && authorizedMember.memberLastName != '') completePct += 25;
            if (authorizedMember.memberEmail != '') completePct += 25;
            if (profiles.contactsActive >= 1) completePct += 25;
            if (profiles.places >= 1) completePct += 25;

            setAccountSetupPct(completePct);
        }
    }, [authorizedMember, profiles]);


    const getTimers = async (mt: any) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('timers', 'all');
            const response = await fetch('https://api.besolowise.com/timers/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });

            if(response.ok) {   
                const obj = await response.json();
                //console.log(obj);
                setTimers(obj);

                const formData = new FormData();
                formData.append('mt', mt);
                formData.append('timers', 'all');
                const responseDaily = await fetch('https://api.besolowise.com/timers/get-daily/', {
                    method: 'POST',
                    credentials: 'include',
                    body: formData
                });

                if(responseDaily.ok) {   
                    const obj = await responseDaily.json();
                    //console.log(obj);
                    setDailyTimers(obj);
                }
                
                const now = new Date();
                const nowDateStr = now.toLocaleTimeString('en-US');
                if(nowDateStr != lastLoadTime) setLastLoadTime(nowDateStr);

            } else {
                showToast({
                    message: 'Response Error.',
                    duration: 3000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection: ' + error + '.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        } 
    };


    //
    // Toggle the Type
    //
    const toggleTimerFreq = (f: string) => {
        setTimerFreq(f);
    };  


    const copyTimer = (e:any, token: string) => {
        e.stopPropagation();
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to COPY this Timer?',
            buttons: [
                {text: 'Cancel',
                 role: 'cancel',
                 cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'Copy',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('mt', authKey.mt);
                            formData.append('token', token);
                            const apiURI = 'https://api.besolowise.com/timers/copy/';
                            const response = await fetch(apiURI, {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                const obj = await response.json(); 
                                //console.log(obj);
                                if(obj.success) {
                                    router.push('/account/timers/', 'back');
                                } else {
                                    showToast({
                                        message: 'Data error.',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response error.',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Connection Error: ' + error,
                                duration: 2000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };
   

    const DSTChip = (s: string) => {
        if (s == '1') 
            return <IonText color={'warning'}>DST</IonText>
        else if (s == '0')  
            return <IonText color={'dark'}>Standard Time</IonText>
    };  

    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonText color={'medium'}><IonIcon icon={timerOutline}></IonIcon> In-Future</IonText>
            case '1': return <IonText color={'secondary'}><IonIcon icon={caretForwardCircleOutline}></IonIcon> Active</IonText>
            case '2': return <IonText color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon> Checked-In</IonText>
            case '3': return <IonText color={'warning'}><IonIcon icon={alertCircleOutline}></IonIcon> Over-Due</IonText>
            case '4': return <IonText color={'danger'}><IonIcon icon={alertCircleOutline}></IonIcon> Alert</IonText>           
            default:  return <IonText color={'warning'}><IonIcon icon={helpCircleOutline}></IonIcon> Unknown</IonText>
        }
    };

    const statusChipDaily = (s: string) => {
        switch(s) {
            case '0': return <><IonText color={'warning'}><IonIcon icon={pauseCircleOutline}></IonIcon> Paused</IonText></>
            case '1': return <><IonText color={'secondary'}><IonIcon icon={caretForwardCircleOutline}></IonIcon> Active</IonText></>
        }
    };

    const alarmDelayText = (s: string) => {
        switch(s) {
            case '0.00': return 'No'
            case '0.25': return '15-min'
            case '0.50': return '30-min'
            case '1.00': return '1-hour'
            case '2.00': return '2-hour'
            case '3.00': return '3-hour'
            case '6.00': return '6-hour'
            case '12.00': return '12-hour'
            case '24.00': return '24-hour'
            default:  return 'Unknown'
        }
    };


    //
    // Open Timer Views
    //
    const viewTimer = (tt: string) => {
        router.push('/account/timer/view/'+tt, 'forward');
    }; 

    const viewDailyTimer = (tt: string) => {
        router.push('/account/timer/view-daily/'+tt, 'forward');
    };


    //
    // Delete Timer
    //
    const confirmDeleteTimer = async (tt: string) => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to REMOVE this Timer?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'REMOVE',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: () => { deleteTimer(tt) },
                }
            ]
        })
    };
    
    const deleteTimer = async (tt: string) => {
        setIsDeleting(true);
        await present('Removing ...');
        try {
            //console.log(authKey.mt);
            const formData = new FormData();
            formData.append('mt', authKey.mt);
            formData.append('token', tt);
            const apiURI = 'https://api.besolowise.com/timers/delete/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    //router.push('/account/timers', 'back');
                    await getTimers(authKey.mt); 
                        await slidingRef.current?.closeOpened();
                } else {
                    showToast({
                        message: 'Data error.',
                        duration: 2000,
                        color: 'danger',
                    });
                }
            } else {
                showToast({
                    message: 'Response error.',
                    duration: 2000,
                    color: 'danger',
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error,
                duration: 2000,
                color: 'danger',
            });
        }  
        setIsDeleting(false);
        dismiss();
    };


    const closeThisSliding = async (ev: React.MouseEvent) => {
        const sliding = (ev.currentTarget as HTMLElement).closest('ion-item-sliding') as HTMLIonItemSlidingElement | null;
        await sliding?.close(); 
    };

    
    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
          await getTimers(authKey.mt);
          await getCurrentTimers(authKey.token);
          event.detail.complete();
          setLoading(false);
        }, 2000);
    };

    const autoRefresh = (prevMinutes: number) => {
        const now = new Date();
        const nowMinutes = now.getMinutes();
        if(prevMinutes === -1 || (nowMinutes == 0 || nowMinutes == 15 || nowMinutes == 30 || nowMinutes == 45) && nowMinutes != prevMinutes) getTimers(authKey.mt);
        setTimeout(() => autoRefresh(nowMinutes), 30000);
    };

    const toggleAlertContent = () => setAlertVisible(!alertVisible);

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar className='ion-text-center'>
                    <IonButtons slot='start'>
                        <IonBackButton color={'tertiary'}>Back</IonBackButton>
                    </IonButtons>
                    <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg">
                
                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12' sizeSm='7'>
                            <h1><IonIcon color={'secondary'} icon={alarmOutline}></IonIcon> Timers<br /><span>Manage your Timer check-ins</span></h1>
                        </IonCol>
                        <IonCol className='ion-margin-bottom top-action-button'  size='12' sizeSm='5'>                            
                            {!loading && alarms < limits.timers && profiles.contactsActive >= 1 &&  
                                <IonButton color={'secondary'} routerLink='/account/timer/create' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Set a New Timer</IonButton>
                            }
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonAccordionGroup className='ion-margin'>
                    <IonAccordion value="info">
                        <IonItem slot='header' color={'light'}>
                            <IonLabel><IonIcon color={'tertiary'} icon={informationCircle} size='large'></IonIcon> What is a SoloWise Timer?</IonLabel>
                        </IonItem>
                        <div slot="content">                
                            <IonCard>
                                <IonCardContent>
                                    <p>A <strong>SoloWise Timer</strong> schedules a check-in for a Place or Route. Timers may be set to run during a one-time event or repeat automatically on selected days of the week.</p>
                                    <p>You can select a saved Place or Route, or create a new one while setting the Timer.</p>
                                    <p>You must have at least one confirmed Contact before you can set a Timer.</p>
                                    <p>One-time Timers require a scheduled start time to provide coverage for a specific period. Daily Timers do not require a start time and automatically cover a 24-hour cycle.</p>
                                    <p>When the check-in time arrives, you will receive a reminder to check in. You must be in a location with an internet or cellular connection, so you are able to check in. Checking in to a Daily Timer will automatically reset the check-in time to the next selected day.</p>
                                    <p>You may set an Alarm Delay to provide a grace period to check in. If you do not check in before the Alarm Delay expires, SoloWise will automatically alert the Contact(s) assigned to the Timer.</p>
                                </IonCardContent>
                            </IonCard>
                        </div>
                    </IonAccordion>
                </IonAccordionGroup>
                
                {!loading && alarms >= limits?.timers &&
                    <IonCard>
                        <IonCardHeader>
                            <IonCardTitle className='ion-margin-bottom ion-text-center' color={'tertiary'}>
                                You've reached the monthly limit of Alarms for your current plan.
                            </IonCardTitle>
                        </IonCardHeader>
                        <IonCardContent>
                            <p className='ion-margin-bottom ion-text-center'>
                                You can not create a new Timer until one of your Alarms expires after one month. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>
                                Or uou can add more Alarms by upgrading to a SoloWise Premium plan. 
                            </p>
                            <p className='ion-margin-bottom ion-text-center'>                            
                                <IonButton className='ion-margin' color={'secondary'} routerLink='/account/plans' routerDirection='forward'><IonIcon icon={addCircleOutline} slot='start'></IonIcon> Upgrade Now</IonButton>
                            </p>
                        </IonCardContent>
                    </IonCard>
                } 

                    
                    {(dailyTimers.length > 0 && !loading)
                        ? dailyTimers.map((timer, index) => (                    
                            <IonCard key={index}> 
                                <IonCardHeader className='cursor-pointer' onClick={() => viewDailyTimer(timer.token)}>
                                    {loading 
                                        ? <>
                                            <IonCardTitle><IonSkeletonText animated={true} style={{ width: '50%' }}></IonSkeletonText></IonCardTitle>
                                            <IonCardSubtitle><IonSkeletonText animated={true} style={{ width: '75%' }}></IonSkeletonText></IonCardSubtitle>
                                        </>
                                        : <>                                      
                                            <IonCardTitle className='timer-title'>
                                                <IonIcon color={'tertiary'} className='ion-margin-end' icon={timer.endPlace == '' ? locationOutline : navigateOutline} />{timer.name}
                                            </IonCardTitle>
                                        </>
                                    }
                                </IonCardHeader>
                                <IonCardContent className='ion-margin-start ion-padding-start'>     
                                    <IonGrid>
                                    {loading
                                        ? <>
                                            <h2><IonSkeletonText animated={true} style={{ width: '30%' }}></IonSkeletonText></h2>
                                        </>
                                        : <>
                                            <IonRow>
                                                <IonCol className='cursor-pointer' onClick={() => viewDailyTimer(timer.token)} size='12' sizeMd='7' sizeLg='6'>
                                                    <p className='timer-status'><IonText color={'tertiary'}>Daily</IonText> | {statusChipDaily(timer.status)}</p>
                                                    <p><strong>{timer.endTime}, {timezoneIANAName(timer.ianaTimezone)} Time</strong></p>
                                                    <p><strong>{timer.daysOfWeek}</strong></p>
                                                    <p>{alarmDelayText(timer.delay)} Alarm Delay</p>   
                                                </IonCol>
                                                <IonCol size='12' sizeMd='5' sizeLg='6' className='ion-text-right position-relative'>
                                                    {timer.statusCheckTime != 0 && 
                                                        <IonChip color={'success'}><IonIcon className='ion-no-margin' icon={notificationsOutline}></IonIcon></IonChip>
                                                    }   
                                                    {timer.alarmTime != 0 && 
                                                        <IonChip color={'danger'}><IonIcon className='ion-no-margin' icon={notificationsOutline}></IonIcon></IonChip>
                                                    }   
                                                    {timer?.alarmTime == 0 && 
                                                    <>
                                                        {deviceCtx.useSlideAction 
                                                        ? <IonItemSliding className='ion-text-right position-absolute' style={{'bottom': '0', 'right': '0'}}>
                                                                <IonItem className='ion-text-right' lines='none'>
                                                                    <IonLabel className='ion-text-right'>
                                                                        <IonIcon className='ion-margin-right' icon={chevronBackOutline} style={{verticalAlign: 'text-bottom'}}></IonIcon>                                  
                                                                        Slide to Remove
                                                                    </IonLabel>
                                                                </IonItem>
                                                                <IonItemOptions>
                                                                    <IonItemOption 
                                                                        color={'remove'} 
                                                                        onClick={async (e) => {
                                                                            await closeThisSliding(e);
                                                                            await deleteTimer(timer.token);
                                                                        }}
                                                                    >
                                                                        <IonIcon slot="start" icon={trashOutline}></IonIcon>
                                                                        Remove
                                                                    </IonItemOption>
                                                                </IonItemOptions>
                                                            </IonItemSliding>
                                                        : <IonButton 
                                                                className='ion-float-end delete-button-outline position-absolute' 
                                                                fill='outline'
                                                                onClick={async (e) => {
                                                                            await confirmDeleteTimer(timer.token);
                                                                        }}
                                                                style={{'bottom': '0', 'right': '0'}}
                                                                >
                                                                    <IonIcon icon={trashOutline}></IonIcon>
                                                            </IonButton>
                                                        }
                                                    </>
                                                    }                                          
                                                </IonCol>
                                            </IonRow>
                                        </>
                                    }
                                    </IonGrid>
                                </IonCardContent>
                            </IonCard>
                        ))
                        : loading
                            ? <>{/*<p className='ion-text-center'>Loading Daily Timers<br /><IonSpinner className='ion-margin-top' name="crescent"></IonSpinner></p>*/}</>
                            : <>
                                    {/*<p className='ion-text-center'>You have no Daily Timers.</p>*/}
                                    {/*profiles.contactsActive < 1 &&
                                        <>
                                            <p className='ion-text-center'><IonIcon color={'warning'} icon={warningOutline}></IonIcon> Before you can set a SoloWise Timer,<br />you must have at least one <strong>confirmed</strong> <Link to='/account/contacts'>SoloWise Contact</Link>.</p>
                                        </>
                                    */}
                                </>
                            
                    }
                

                    {(timers.length > 0 && !loading)
                        ? timers.map((timer, index) => (                    
                            <IonCard key={index}> {/*  routerDirection='forward' routerLink={`/account/timer/view/${timer.token}`} */}
                                <IonCardHeader className='cursor-pointer' onClick={() => viewTimer(timer.token)}>
                                    {loading 
                                        ? <>
                                            <IonCardTitle><IonSkeletonText animated={true} style={{ width: '50%' }}></IonSkeletonText></IonCardTitle>
                                            <IonCardSubtitle><IonSkeletonText animated={true} style={{ width: '75%' }}></IonSkeletonText></IonCardSubtitle>
                                        </>
                                        : <>                                      
                                            <IonCardTitle className='timer-title'>
                                                <IonIcon color={'tertiary'} className='ion-margin-end' icon={timer.endPlace == '' ? locationOutline : navigateOutline} />{timer.name}
                                            </IonCardTitle>
                                        </>
                                    }
                                </IonCardHeader>
                                <IonCardContent className='ion-margin-start ion-padding-start cursor-pointer'>
                                    {loading
                                        ? <>
                                            <h2><IonSkeletonText animated={true} style={{ width: '30%' }}></IonSkeletonText></h2>
                                        </>
                                        : <>
                                            <IonRow className='cursor-pointer'>
                                                <IonCol size='12' sizeSm='7' onClick={() => viewTimer(timer.token)}>
                                                    <p className='timer-status'><IonText color={'tertiary'}><strong>One-time</strong></IonText> | {statusChip(timer.status)}</p>
                                                    <p><strong>{timer.startTime} - {timer.endTime}</strong></p>
                                                    <p>{timezoneIANAName(timer.ianaTimezone)} Time</p> 
                                                    <p>{alarmDelayText(timer.delay)} Alarm Delay</p>  
                                                </IonCol>
                                                <IonCol size='12' sizeSm='5' className='ion-text-right position-relative'>
                                                    {timer?.alarm >=1 && timer?.status != '4' && 
                                                    <IonChip color={'danger'}><IonIcon className='ion-no-margin' icon={notificationsOutline}></IonIcon> {timer.alarm}</IonChip>
                                                    }   
                                                    {!timer.alarm && 
                                                    <>
                                                        {deviceCtx.useSlideAction 
                                                        ? <IonItemSliding className='ion-text-right position-absolute' style={{'bottom': '0', 'right': '0'}}>
                                                                <IonItem className='ion-text-right' lines='none'>
                                                                    <IonLabel className='ion-text-right'>
                                                                        <IonIcon className='ion-margin-right' icon={chevronBackOutline} style={{verticalAlign: 'text-bottom'}}></IonIcon>                                  
                                                                        Slide to Remove
                                                                    </IonLabel>
                                                                </IonItem>
                                                                <IonItemOptions>
                                                                    <IonItemOption 
                                                                        color={'remove'} 
                                                                        onClick={async (e) => {
                                                                            await closeThisSliding(e);
                                                                            await deleteTimer(timer.token);
                                                                        }}
                                                                    >
                                                                        <IonIcon slot="start" icon={trashOutline}></IonIcon>
                                                                        Remove
                                                                    </IonItemOption>
                                                                </IonItemOptions>
                                                            </IonItemSliding>
                                                        : <IonButton 
                                                                className='ion-margin ion-float-end delete-button-outline position-absolute' 
                                                                fill='outline'
                                                                onClick={async (e) => {
                                                                            await confirmDeleteTimer(timer.token);
                                                                        }}
                                                                style={{'bottom': '0', 'right': '0'}}>
                                                                    <IonIcon icon={trashOutline}></IonIcon>
                                                            </IonButton>
                                                        }
                                                    </>
                                                    }                                         
                                                </IonCol>
                                            </IonRow>
                                        </>
                                    }
                                </IonCardContent>
                            </IonCard>
                        ))
                        : loading
                            ? <p className='ion-text-center'>Loading Timers<br /><IonSpinner className='ion-margin-top' name="crescent"></IonSpinner></p>
                            : <>
                                    {/*<p className='ion-text-center'>You have no  Timers.</p>
                                    {profiles.contactsActive < 1 &&
                                        <>
                                            <p className='ion-text-center'><IonIcon color={'warning'} icon={warningOutline}></IonIcon> Before you can set a SoloWise Timer,<br />you must have at least one <strong>confirmed</strong> <Link to='/account/contacts'>SoloWise Contact</Link>.</p>
                                        </>
                                    }*/}
                                </>
                            
                    }

                    {(timers.length === 0 && dailyTimers.length === 0 && !loading) &&
                        <>
                            <p className='ion-text-center'>You have no  Timers set.</p>
                            {profiles.contactsActive < 1 &&
                                <p className='ion-text-center'><IonIcon color={'warning'} icon={warningOutline}></IonIcon> Before you can set a SoloWise Timer,<br />you must have at least one <strong>confirmed</strong> <Link to='/account/contacts'>SoloWise Contact</Link>.</p>
                            }
                        </>
                    }

                {/*!loading && alarms < limits.timers &&  profiles.contactsActive >= 1 &&
                    <IonFab slot="fixed" vertical="bottom" horizontal="end">
                        <IonFabButton color={'secondary'} routerLink={'/account/timer/create'} routerDirection='forward'>
                            <IonIcon icon={add} size='large'></IonIcon>
                        </IonFabButton>
                     </IonFab>
                */}
            </IonContent>
        </IonPage>
    );
};

export default Timers;